import qs from 'qs';
import { useQuery } from 'react-query';

import { axios } from 'lib';

const getFrameworkAgreementsConsortiumGroupFilesCount = (faId, facId) => {
  return axios.get(
    `/api/framework_agreements/${faId}/consortium_groups/${facId}/files/count`
  );
};

export const useFrameworkAgreementsConsortiumGroupFilesCount = (faId, facId, options = {}) => {
  return useQuery(
    `framework-agreement-consortium-group-${facId}-count`,
    () => getFrameworkAgreementsConsortiumGroupFilesCount(faId, facId),
    {
      //@ts-ignore
      initialData: { data: { count: 0 } },
      select: ({ data }) => data,
      ...options,
    }
  );
}
